import {ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {PlaceholderChildComponent} from '@ispm/layout/classes/placeholder-child-component.abstract';
import {cloneDeep} from 'lodash';
import {PlacementData, PlacementNodeData} from '@ispm-client/modules/bpmn-modeler/models/placement.data';
import {SelectorUrlBuilderService} from '@ispm-client/modules/bpmn-modeler/service/selector-url-builder.service';
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {Store} from '@ngrx/store';
import {
  NavigateToNodeWithData
} from "@ispm-client/modules/bpmn-modeler/store/actions/node-navigator.action";
import {ClearNodeSelection, UpdateTreatmentNodesProperties} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {NodesPlaceViewCalculationsService} from "../../../app/curation/services/nodes-place-view-calculations.service";

@Component({
  selector: 'ispm-clinical-trial-selector',
  templateUrl: './clinical-trial-selector.component.html',
  styleUrls: ['./clinical-trial-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ClinicalTrialSelectorComponent extends PlaceholderChildComponent<any> implements OnInit {
  public data: PlacementData;
  public revisedEntitiesRevisionsData: any;

  constructor(
    private _changeDetector: ChangeDetectorRef,
    private selectorUrlBuilderService: SelectorUrlBuilderService,
    private store$: Store<State>,
    private nodesPlaceViewCalculationsService: NodesPlaceViewCalculationsService
  ) {
    super();
  }

  ngOnInit() {
    this.data = cloneDeep(this.payload.data);
    this.revisedEntitiesRevisionsData = cloneDeep(this.payload.revisedEntitiesRevisionsData);
  }

  public hasClinicalTrial(): boolean {
    return this.data && this.data.clinicalTrial && this.data.clinicalTrial['display'];
  }

  public buildClinicalTrialUrl(data: any) {
    return this.selectorUrlBuilderService.getSelectorUrl(data);
  }

  public openClinicalTrialUrl() {
    let url = this.buildClinicalTrialUrl(this.data.clinicalTrial);
    if (url) {
      window.open(url, "_blank");
    }
  }

  public updateItemValue(event) {
    let form = event.form;
    let relatedEntity;
    for (const entity of this.revisedEntitiesRevisionsData) {
      relatedEntity = entity.revisions.find(rev => rev.code === form.clinicalTrial.revisionId);
      if (relatedEntity) {
        break;
      }
    }

    form.clinicalTrial.curationDataId = relatedEntity ? relatedEntity.curationDataId : form.clinicalTrial.curationDataId;

    if (event.updated && event.updated.includes('clinicalTrial')) {
      let nodes: string[] = this.data.nodes.map((node: PlacementNodeData) => {
        return node.nodeId;
      });
      if (nodes && nodes.length > 0)
        this.store$.dispatch(new UpdateTreatmentNodesProperties({nodes, data: form}));
    }

    /* The 3rd parameter below is added because 'form' contains the 'nodes' that were taken from the payload when
     * this component was created; any changes to the node list since then are reflected in 'this.data.nodes' but not
     * in 'form'. Hence we must not use the 'nodes' from 'form', as it's not up-to-date.
     * Note: This 'form' is the one that uses the clinical-trial-selector dynamic form; it has no 'nodes' element in the
     * configuration. It is a *different* form object from the one that is received by 'updateNodes' below.
     */
    Object.assign(this.data, form, {'nodes': this.data.nodes});
    this.callback(this.data);
  }

  public updateNodes(form) {
    if (form.clinicalTrialNodes) {
      switch (form.clinicalTrialNodes.action) {
        case 'itemSelected': {
          let node = form.clinicalTrialNodes.data;
          if (node?.code) {
            const data = this.nodesPlaceViewCalculationsService.calculateShiftData();
            this.store$.dispatch(new NavigateToNodeWithData({nodeId: node.code, openPanel: false, data: data}));
          } else
            this.store$.dispatch(new ClearNodeSelection({}));
          break;
        }
        case 'updateData': {
          this.data.nodes = form.clinicalTrialNodes.data ? form.clinicalTrialNodes.data : [];
          this.callback(this.data, true);
          break;
        }
        case 'itemRemoved': {
          if (form.clinicalTrialNodes.data) {
            this.data.nodes = form.clinicalTrialNodes.data.nodes ? form.clinicalTrialNodes.data.nodes : [];
            this.callback(this.data, true, form.clinicalTrialNodes.data.removedNode);
            //Remove node's selection and a clinical trial ID on the PW tree node
            this.store$.dispatch(new ClearNodeSelection({}));
          }
          break;
        }
        default:
          break;
      }
    }
  }

  public save() {
    this.callback(this.data);
  }

  public beforeClose() {
  }
}
